import React, { useCallback } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { PayrollCalendar } from '@/modules/Renewals/renewals.types';

import PayrollCalendarCard from './PayrollCalendarCard';

interface Props {
  payrollCalendars?: PayrollCalendar[];
  onEditCalendar?: (calendarId: string) => void;
  testId?: string;
}

const PayrollCalendarSection: React.FC<Props> = ({
  payrollCalendars,
  onEditCalendar,
  testId = 'payroll-calendar-section',
}) => {
  const resolveLinkedPlanNames = useCallback(
    (calendar: PayrollCalendar): string[] => calendar.calendarPlanCodes ?? [],
    []
  );

  if (!payrollCalendars || payrollCalendars.length === 0) {
    return null;
  }

  return (
    <Box data-testid={testId} margin={{ top: 'l' }}>
      <Inscription weight="bold" size="32px" lineHeight="44px" color="textTitle" margin={{ bottom: 'l' }}>
        Payroll Calendars
      </Inscription>
      <Box background="module" pad="l" round="container1Round" gap="spacing12">
        {payrollCalendars.map((calendar, index) => (
          <PayrollCalendarCard
            key={calendar.id ?? index}
            calendar={calendar}
            linkedPlanNames={resolveLinkedPlanNames(calendar)}
            onEdit={onEditCalendar}
            testId={`${testId}_item_${calendar.id ?? index}`}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PayrollCalendarSection;
